import { Home, Mic, BookOpen, Settings } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import Logo from '@/components/branding/Logo';

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      {/* Desktop top nav */}
      <nav className="hidden md:flex items-center justify-between px-8 lg:px-12 py-4 bg-card/80 backdrop-blur-md border-b border-border sticky top-0 z-40">
        <button onClick={() => navigate('/home')} className="cursor-pointer" aria-label="Home">
          <Logo variant="horizontal" size="sm" />
        </button>
        <div className="flex items-center gap-1">
          <NavLink icon={<Home size={18} />} label="Home" active={isActive('/home')} onClick={() => navigate('/home')} />
          <NavLink icon={<BookOpen size={18} />} label="Practice" active={isActive('/practice')} onClick={() => navigate('/practice')} />
          <NavLink icon={<Settings size={18} />} label="Settings" active={isActive('/settings')} onClick={() => navigate('/settings')} />
        </div>
        <button
          onClick={() => navigate('/interview/intro')}
          className="flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-br from-primary to-primary-dark text-white text-sm font-medium font-sans shadow-sm hover:shadow-md transition-shadow cursor-pointer"
        >
          <Mic size={16} />
          Start Interview
        </button>
      </nav>

      {/* Mobile bottom nav */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-card border-t border-border px-6 pb-[env(safe-area-inset-bottom)] flex items-center justify-around h-20">
        <MobileTab icon={<Home size={22} />} active={isActive('/home')} onClick={() => navigate('/home')} />
        <button
          onClick={() => navigate('/interview/intro')}
          className="w-16 h-16 -mt-6 rounded-full bg-gradient-to-br from-primary to-primary-dark flex items-center justify-center shadow-lg cursor-pointer"
        >
          <Mic size={28} className="text-white" />
        </button>
        <MobileTab icon={<BookOpen size={22} />} active={isActive('/practice')} onClick={() => navigate('/practice')} />
      </nav>
    </>
  );
}

function NavLink({ icon, label, active, onClick }: { icon: ReactNode; label: string; active: boolean; onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className={`relative flex items-center gap-2 px-4 py-2 rounded-lg transition-colors cursor-pointer ${
        active ? 'text-primary' : 'text-text-muted hover:text-text-primary'
      }`}
    >
      {icon}
      <span className="text-sm font-medium font-sans">{label}</span>
      {active && (
        <span className="absolute left-3 right-3 -bottom-[17px] h-0.5 bg-primary rounded-full" />
      )}
    </button>
  );
}

function MobileTab({ icon, active, onClick }: { icon: ReactNode; active: boolean; onClick: () => void }) {
  return (
    <button onClick={onClick} className={`p-3 rounded-xl transition-colors cursor-pointer ${active ? 'text-primary' : 'text-text-muted'}`}>
      {icon}
    </button>
  );
}
